/* AestheticsXart - "Find your scale" size guide for painting product pages */
(function () {
  if (window.axSizeGuideLoaded) return;
  window.axSizeGuideLoaded = true;

  var SCENE_W = 260;
  var SCENE_H = 222;
  var FLOOR = 8;
  var PERSON_X = 36;
  var CONSOLE_X = 130;
  var CONSOLE_W = 100;
  var CONSOLE_H = 81;
  var EYE_LEVEL = 145;

  var FIGURES = {
    woman: {
      label: 'Woman',
      cm: 165,
      ft: '5′5″',
      svg:
        '<svg viewBox="0 0 60 180" preserveAspectRatio="none" aria-hidden="true"><g fill="currentColor"><ellipse cx="30" cy="13" rx="11" ry="12.5"/><path d="M19 14q0 16 4 20h14q4-4 4-20z"/><rect x="26.5" y="21" width="7" height="8" rx="2"/><path d="M16 28h28a7 7 0 0 1 7 7l-4 40 7 42H10l7-42-4-40a7 7 0 0 1 7-7z"/><rect x="5" y="31" width="8" height="58" rx="4"/><rect x="47" y="31" width="8" height="58" rx="4"/><rect x="19" y="115" width="9" height="61" rx="3"/><rect x="32" y="115" width="9" height="61" rx="3"/><rect x="17" y="174" width="12" height="6" rx="3"/><rect x="31" y="174" width="12" height="6" rx="3"/></g></svg>',
    },
    man: {
      label: 'Man',
      cm: 180,
      ft: '5′11″',
      svg:
        '<svg viewBox="0 0 60 180" preserveAspectRatio="none" aria-hidden="true"><g fill="currentColor"><ellipse cx="30" cy="12" rx="9" ry="11"/><rect x="26" y="20" width="8" height="9" rx="2"/><path d="M14 27h32a8 8 0 0 1 8 8l-3 58H9L6 35a8 8 0 0 1 8-8z"/><rect x="2" y="30" width="9" height="62" rx="4.5"/><rect x="49" y="30" width="9" height="62" rx="4.5"/><path d="M13 90h16l-1 86H16z"/><path d="M31 90h16l-3 86H32z"/><rect x="12" y="174" width="17" height="6" rx="3"/><rect x="31" y="174" width="17" height="6" rx="3"/></g></svg>',
    },
  };

  var CONSOLE_SVG =
    '<svg viewBox="0 -9 100 90" preserveAspectRatio="none" aria-hidden="true"><path d="M38 0h24l-3-5q-9-2-18 0z" fill="#bdb2a1"/><rect x="0" y="0" width="100" height="4" rx="0.8" fill="#3d322a"/><rect x="5" y="4" width="2.4" height="77" fill="#2c2520"/><rect x="92.6" y="4" width="2.4" height="77" fill="#2c2520"/><rect x="5" y="60" width="90" height="1.8" fill="#2c2520"/></svg>';

  var CLOSE_SVG =
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" fill="none"/></svg>';

  var figure = 'man';
  try {
    figure = localStorage.getItem('axSgFigure') || 'man';
  } catch (e) {}
  if (!FIGURES[figure]) figure = 'man';

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function fmt(n) {
    return String(Math.round(n * 10) / 10);
  }

  function parseSize(el) {
    var v = el.getAttribute('data-value') || '';
    var inch = v.match(/(\d+(?:\.\d+)?)\s*["″]?\s*[x×]\s*(\d+(?:\.\d+)?)\s*["″]/i);
    var cm = v.match(/(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)\s*cm/i);
    var wi = inch ? parseFloat(inch[1]) : null;
    var hi = inch ? parseFloat(inch[2]) : null;
    var w = cm ? parseFloat(cm[1]) : wi * 2.54;
    var h = cm ? parseFloat(cm[2]) : hi * 2.54;
    if (!wi && w) {
      wi = Math.round(w / 2.54);
      hi = Math.round(h / 2.54);
    }
    if (!w || !h) return null;
    return {
      value: v,
      wi: wi,
      hi: hi,
      w: w,
      h: h,
      price: el.getAttribute('data-price') || '',
      selected: el.hasAttribute('data-selected'),
    };
  }

  function hint(s) {
    var m = Math.max(s.w, s.h);
    if (m <= 40) return 'Shelf or small wall';
    if (m <= 60) return 'Bedside wall';
    if (m <= 90) return 'Above a console';
    return 'Statement wall';
  }

  function px(x) {
    return (x / SCENE_W) * 100 + '%';
  }
  function py(y) {
    return (y / SCENE_H) * 100 + '%';
  }

  function place(el, x, y, w, h) {
    el.style.left = px(x);
    el.style.bottom = py(y + FLOOR);
    if (w != null) el.style.width = px(w);
    if (h != null) el.style.height = py(h);
  }

  var state = null;

  function render() {
    var s = state.sizes[state.index];
    var fig = FIGURES[figure];
    var root = state.root;

    root.querySelector('.ax-sg__dims').innerHTML = esc(fmt(s.wi)) + '″ <span>×</span> ' + esc(fmt(s.hi)) + '″';
    root.querySelector('.ax-sg__hint').textContent = hint(s);

    var person = root.querySelector('.ax-sg__person');
    person.innerHTML = fig.svg;
    var personW = fig.cm / 3;
    place(person, PERSON_X, 0, personW, fig.cm);

    var pLine = root.querySelector('.ax-sg__line--person');
    place(pLine, PERSON_X - 7, 0, null, fig.cm);
    pLine.querySelector('span').textContent = fig.ft;

    place(root.querySelector('.ax-sg__console'), CONSOLE_X, 0, CONSOLE_W, CONSOLE_H + 9);
    var cLine = root.querySelector('.ax-sg__line--console');
    place(cLine, CONSOLE_X + CONSOLE_W + 4, 0, null, CONSOLE_H);

    var artX = CONSOLE_X + CONSOLE_W / 2 - s.w / 2;
    var artY = Math.max(EYE_LEVEL - s.h / 2, CONSOLE_H + 14);
    if (artY + s.h > SCENE_H - FLOOR - 4) artY = SCENE_H - FLOOR - 4 - s.h;
    var art = root.querySelector('.ax-sg__art');
    place(art, artX, artY, s.w, s.h);
    art.classList.toggle('ax-sg__art--landscape', s.w > s.h);

    var aLine = root.querySelector('.ax-sg__line--art');
    place(aLine, artX + s.w + 3, artY, null, s.h);
    aLine.querySelector('span').textContent = fmt(s.hi) + '″';

    root.querySelector('.ax-sg__caption').innerHTML =
      'Reference figure: <strong>' +
      fig.label +
      ', ' +
      fig.ft +
      ' (' +
      fig.cm +
      ' cm)</strong> · console at <strong>32″ (81 cm)</strong>';

    root.querySelectorAll('.ax-sg__card').forEach(function (card, i) {
      var cs = state.sizes[i];
      card.querySelector('.ax-sg__card-in').textContent = fmt(cs.wi) + '×' + fmt(cs.hi) + '″';
      card.querySelector('.ax-sg__card-cm').textContent = fmt(cs.w) + ' × ' + fmt(cs.h) + ' cm';
      var on = i === state.index;
      card.classList.toggle('is-active', on);
      card.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    root.querySelectorAll('[data-fig]').forEach(function (b) {
      var on = b.getAttribute('data-fig') === figure;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    var choose = root.querySelector('.ax-sg__choose');
    choose.textContent =
      'Choose ' + fmt(s.wi) + '″ × ' + fmt(s.hi) + '″' + (s.price ? ' · ' + s.price : '');
  }

  function setArtBackground() {
    if (!state || !state.img) return;
    var art = state.root.querySelector('.ax-sg__art');
    art.style.backgroundImage = 'url("' + state.img + '")';
    var c = state.crop;
    if (c) {
      art.style.backgroundSize = 100 / c.bw + '% ' + 100 / c.bh + '%';
      art.style.backgroundPosition =
        (c.bw < 0.999 ? (c.x0 / (1 - c.bw)) * 100 : 50) + '% ' + (c.bh < 0.999 ? (c.y0 / (1 - c.bh)) * 100 : 50) + '%';
    } else {
      art.style.backgroundSize = 'cover';
      art.style.backgroundPosition = 'center';
    }
  }

  // Finds the artwork inside the (often transparent) product image, to crop it and detect its orientation
  function loadArt(src) {
    var image = new Image();
    image.crossOrigin = 'anonymous';
    image.onload = function () {
      if (!state || state.img !== src) return;
      try {
        var W = 160;
        var H = Math.max(1, Math.round((W * image.naturalHeight) / image.naturalWidth));
        var canvas = document.createElement('canvas');
        canvas.width = W;
        canvas.height = H;
        var ctx = canvas.getContext('2d');
        ctx.drawImage(image, 0, 0, W, H);
        var data = ctx.getImageData(0, 0, W, H).data;
        var x0 = W, y0 = H, x1 = -1, y1 = -1;
        for (var y = 0; y < H; y++) {
          for (var x = 0; x < W; x++) {
            if (data[(y * W + x) * 4 + 3] > 20) {
              if (x < x0) x0 = x;
              if (x > x1) x1 = x;
              if (y < y0) y0 = y;
              if (y > y1) y1 = y;
            }
          }
        }
        if (x1 > x0 && y1 > y0) {
          var crop = { x0: x0 / W, y0: y0 / H, bw: (x1 - x0 + 1) / W, bh: (y1 - y0 + 1) / H };
          state.crop = crop;
          var aspect = (crop.bw * image.naturalWidth) / (crop.bh * image.naturalHeight);
          state.sizes.forEach(function (s) {
            if ((aspect > 1.05 && s.w < s.h) || (aspect < 0.95 && s.w > s.h)) {
              var t = s.w;
              s.w = s.h;
              s.h = t;
              t = s.wi;
              s.wi = s.hi;
              s.hi = t;
            }
          });
          render();
        }
      } catch (e) {}
      setArtBackground();
    };
    image.onerror = setArtBackground;
    image.src = src;
  }

  function close() {
    if (!state) return;
    var st = state;
    state = null;
    document.removeEventListener('keydown', onKey, true);
    st.root.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden');
    setTimeout(function () {
      st.root.remove();
    }, 250);
    if (st.trigger && st.trigger.isConnected) st.trigger.focus();
  }

  function onKey(event) {
    if (event.key === 'Escape') {
      event.stopPropagation();
      close();
    }
  }

  function choose() {
    var s = state.sizes[state.index];
    var selects = state.selects;
    if (selects && selects.isConnected) {
      var input = Array.prototype.find.call(selects.querySelectorAll('fieldset input[type="radio"]'), function (r) {
        return r.value === s.value;
      });
      if (input && !input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    close();
  }

  function open(trigger) {
    var selects = trigger.closest('variant-selects');
    var tpl = selects && selects.querySelector('template[data-ax-size-guide-tpl]');
    if (!tpl) return;

    var sizes = [];
    Array.prototype.forEach.call(tpl.content.querySelectorAll('[data-size]'), function (el) {
      var s = parseSize(el);
      if (s) sizes.push(s);
    });
    if (!sizes.length) return;
    var index = Math.max(
      0,
      sizes.findIndex(function (s) {
        return s.selected;
      })
    );

    var img = tpl.getAttribute('data-img');
    var title = tpl.getAttribute('data-title') || 'this piece';

    var root = document.createElement('div');
    root.className = 'ax-sg';
    root.innerHTML =
      '<div class="ax-sg__backdrop" data-ax-sg-close></div>' +
      '<div class="ax-sg__panel" role="dialog" aria-modal="true" aria-labelledby="AxSgTitle">' +
      '<header class="ax-sg__head">' +
      '<div class="ax-sg__intro"><p class="ax-sg__eyebrow">Size guide</p>' +
      '<h2 class="ax-sg__title" id="AxSgTitle">Find your scale</h2>' +
      '<p class="ax-sg__sub">See ' + esc(title) + ' at every size, next to a person and a 32″ console.</p></div>' +
      '<div class="ax-sg__toggle" role="group" aria-label="Reference figure">' +
      '<button type="button" data-fig="woman">Woman</button><button type="button" data-fig="man">Man</button></div>' +
      '<button type="button" class="ax-sg__close" data-ax-sg-close aria-label="Close">' + CLOSE_SVG + '</button>' +
      '</header>' +
      '<div class="ax-sg__body">' +
      '<div class="ax-sg__stage">' +
      '<p class="ax-sg__label"><span class="ax-sg__dims"></span><span class="ax-sg__hint"></span></p>' +
      '<div class="ax-sg__scene">' +
      '<div class="ax-sg__floor"></div>' +
      '<div class="ax-sg__line ax-sg__line--person"><span></span></div>' +
      '<div class="ax-sg__person"></div>' +
      '<div class="ax-sg__console">' + CONSOLE_SVG + '</div>' +
      '<div class="ax-sg__line ax-sg__line--console"><span>32″</span></div>' +
      '<div class="ax-sg__art"></div>' +
      '<div class="ax-sg__line ax-sg__line--art"><span></span></div>' +
      '</div>' +
      '<p class="ax-sg__caption"></p>' +
      '</div>' +
      '<div class="ax-sg__side">' +
      '<p class="ax-sg__side-title">All sizes for this piece</p>' +
      '<div class="ax-sg__cards">' +
      sizes
        .map(function (s, i) {
          return (
            '<button type="button" class="ax-sg__card" data-index="' + i + '">' +
            '<span class="ax-sg__card-in">' + fmt(s.wi) + '×' + fmt(s.hi) + '″</span>' +
            '<span class="ax-sg__card-cm">' + fmt(s.w) + ' × ' + fmt(s.h) + ' cm</span>' +
            '</button>'
          );
        })
        .join('') +
      '</div>' +
      '<button type="button" class="ax-sg__choose"></button>' +
      '<p class="ax-sg__note">Printed to order and shipped free worldwide. Format and frame are chosen on the product page.</p>' +
      '</div>' +
      '</div>' +
      '</div>';

    document.body.appendChild(root);
    state = { root: root, sizes: sizes, index: index, selects: selects, trigger: trigger, img: img, crop: null };

    root.addEventListener('click', function (event) {
      if (event.target.closest('[data-ax-sg-close]')) return close();
      var card = event.target.closest('.ax-sg__card');
      if (card) {
        state.index = parseInt(card.getAttribute('data-index'), 10);
        return render();
      }
      var fig = event.target.closest('[data-fig]');
      if (fig) {
        figure = fig.getAttribute('data-fig');
        try {
          localStorage.setItem('axSgFigure', figure);
        } catch (e) {}
        return render();
      }
      if (event.target.closest('.ax-sg__choose')) choose();
    });
    document.addEventListener('keydown', onKey, true);

    render();
    if (img) {
      setArtBackground();
      loadArt(img);
    }
    document.body.classList.add('overflow-hidden');
    requestAnimationFrame(function () {
      root.classList.add('is-open');
      root.querySelector('.ax-sg__close').focus();
    });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest && event.target.closest('[data-ax-size-guide]');
    if (!trigger) return;
    event.preventDefault();
    open(trigger);
  });
})();